import React, { useState, useEffect } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import Navbar           from './components/Navbar';
import HeroSection      from './components/HeroSection';
import FeaturesSection  from './components/FeaturesSection';
import HowItWorks       from './components/HowItWorks';
import DetectionSection from './components/DetectionSection';
import DiseasesSection  from './components/DiseasesSection';
import FeedbackSection  from './components/FeedbackSection';
import BlogSection      from './components/BlogSection';
import AboutSection     from './components/AboutSection';
import ContactSection   from './components/ContactSection';
import Footer           from './components/Footer';
import AdminPanel       from './components/AdminPanel';
import BlogPostPage     from './pages/BlogPostPage';
import BlogListingPage  from './pages/BlogListingPage';

const SECTIONS = ['hero','features','how-it-works','detect','diseases','blog','feedback','about','contact'];

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

function HomePage({ showAdmin, setShowAdmin }) {
  const [activeSection, setActiveSection] = useState('hero');

  useEffect(() => {
    const onScroll = () => {
      let current = 'hero';
      for (const id of SECTIONS) {
        const el = document.getElementById(id);
        if (el && window.scrollY >= el.offsetTop - 110) current = id;
      }
      setActiveSection(current);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    const runReveal = () => {
      document.querySelectorAll('.reveal:not(.visible)').forEach(el => {
        const rect = el.getBoundingClientRect();
        if (rect.top < window.innerHeight - 60) el.classList.add('visible');
      });
    };
    runReveal();
    window.addEventListener('scroll', runReveal, { passive: true });
    const t1 = setTimeout(runReveal, 200);
    const t2 = setTimeout(runReveal, 600);
    return () => {
      window.removeEventListener('scroll', runReveal);
      clearTimeout(t1); clearTimeout(t2);
    };
  }, []);

  useEffect(() => {
    const onKey = (e) => { if (e.ctrlKey && e.shiftKey && e.key === 'A') setShowAdmin(true); };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [setShowAdmin]);

  return (
    <>
      {showAdmin && <AdminPanel onClose={() => setShowAdmin(false)} />}
      <Navbar activeSection={activeSection} onAdminClick={() => setShowAdmin(true)} />
      <main>
        <HeroSection />
        <FeaturesSection />
        <HowItWorks />
        <DetectionSection />
        <DiseasesSection />
        <BlogSection />
        <FeedbackSection />
        <AboutSection />
        <ContactSection />
      </main>
      <Footer onAdminClick={() => setShowAdmin(true)} />
    </>
  );
}

export default function App() {
  const [showAdmin, setShowAdmin] = useState(false);
  return (
    <>
      <ScrollToTop />
      <Routes>
        <Route path="/"           element={<HomePage showAdmin={showAdmin} setShowAdmin={setShowAdmin} />} />
        <Route path="/blog"       element={<BlogListingPage />} />
        <Route path="/blog/:slug" element={<BlogPostPage />} />
        <Route path="*"           element={<HomePage showAdmin={showAdmin} setShowAdmin={setShowAdmin} />} />
      </Routes>
    </>
  );
}
